import { DeviceData } from "../../../../../../API";
import { extractDeviceNameFromId } from "../../../../../../common/utils/getEntityName";
import LiveViewDialog from "../dialog/LiveViewDialog";
import DeviceImageListItemBarTitleContent from "./DeviceImageListItemBarTitleContent";

interface IDeviceImageListItemBarTitleProps {
  deviceName: string;
  deviceId: string;
  imageDate?: string;
  nodeId: string;
  locationName: string;

  deviceData: DeviceData;
  isReady: boolean;
  setIsReady: (value: boolean) => void;
  currentDevice: string;
  open: boolean;

  setOpen: (value: boolean) => void;
  onLiveViewClick: () => void;
}

const DeviceImageListItemBarTitle = ({
  deviceName,
  imageDate,
  deviceId,
  nodeId,
  locationName,
  deviceData,
  isReady,
  setIsReady,
  currentDevice,
  open,
  setOpen,
  onLiveViewClick: onLiveViewClick,
}: IDeviceImageListItemBarTitleProps): JSX.Element => {
  const { extractedDeviceName } = extractDeviceNameFromId(deviceId);

  const { hasZoom, hasPanTilt } = deviceData;

  return (
    <>
      <LiveViewDialog
        open={open}
        setOpen={setOpen}
        deviceId={deviceId}
        deviceName={extractedDeviceName}
        locationName={locationName}
        nodeId={nodeId}
        hasPanTilt={hasPanTilt}
        hasZoom={hasZoom}
        setIsReady={setIsReady}
        deviceData={deviceData}
        currentDevice={currentDevice}
      />

      <DeviceImageListItemBarTitleContent
        deviceId={deviceId}
        deviceName={extractedDeviceName}
        locationName={locationName}
        imageDate={imageDate}
        nodeId={nodeId}
        hasPanTilt={hasPanTilt}
        isReady={isReady}
        onLiveViewClick={onLiveViewClick}
        recentFrame={deviceData.recentFrame || ""}
      />
    </>
  );
};

export default DeviceImageListItemBarTitle;
